import React from "react";
import { FaWhatsapp } from "react-icons/fa"; // usamos react-icons


const HeroInfo = () => {
  return (
    <div className="max-w-6xl mx-auto mt-6 px-4 md:px-0 text-center md:text-left">
      <p className="text-gray-700 text-base md:text-lg leading-relaxed">
        Dirigite a la sección de <span className="font-bold text-amber-500">Ventas </span> 
        para ver y seleccionar nuestros productos. Tenemos <span className="font-semibold">insumos ortopédicos </span> 
        e <span className="font-semibold">insumos médicos</span>. Además, contamos con el servicio de 
        <span className="font-bold text-amber-500"> Alquiler Ortopédico</span>. Consultanos para más información. Nos encontramos en San Jose de la Dormida, Los Inmigrantes 368.
      </p>
  <a
        href="https://wa.me/543512191101?text=Hola%20quiero%20consultar%20sobre%20sus%20productos"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 rounded-full p-4 shadow-lg hover:bg-green-600 transition transform hover:scale-110"
      >
        <FaWhatsapp className="text-white text-3xl" />
      </a>
    </div>
    
  );
};

export default HeroInfo;
